module.exports = __webpack_public_path__ + "img/prestashop-logo-2.png";